import {
    Flex,
    Heading,
    Image,
    Spinner,
    Text,
    useColorMode
} from '@chakra-ui/react';
import { useEffect, useState } from 'react'; // Import useState and useEffect
import Layout from '../../components/layout';
import Logos from '../../images/logos';

const LoadingScreen = () => {
    const { colorMode } = useColorMode();
    return (
        <Layout colorMode={colorMode}>
            <Flex align="center" justify="center" w="full" h="100vh">
                <Spinner />
            </Flex>
        </Layout>
    );
}

export default function Error() {
  const { colorMode } = useColorMode();
  const [isLoading, setIsLoading] = useState(true); // Add isLoading state

  useEffect(() => {
    // Use a setTimeout to simulate loading for 1 second
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Clear the timer if the component unmounts
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  console.log(`src/images/logos/${colorMode}/sharp-sports.svg`);

  return (
    <Layout colorMode={colorMode}>
      <Flex direction="column" align="center" gap="64px" w="full" textAlign="center">
        <Image src={Logos[colorMode]['ss']} alt="Sharp Sports" />
        <Flex direction="column" align="center" gap="24px">
          <Heading size="lg">Something went wrong... please try again</Heading>
          <Text>
            If the issue persists, make sure you allow popups in your browser settings and/or turn off any adblockers for
          </Text>
          <Text
            as="a"
            href="https://sharpsports.io"
            mt="-10px"
            color={colorMode == 'light' ? 'midnightBlue' : 'skyBlue'}
            textDecor="underline"
          >
            sharpsports.io
          </Text>
        </Flex>
      </Flex>
    </Layout>
  );
}
